module.exports = __webpack_public_path__ + "static/og-b9e8d7f3248410d3afb8136e157bf820.png";